import { MAIL, MAPI } from 'newJs/config';

const { FIELD_LIST: MFL, WORDS: MW } = MAPI;
const MSD = MAIL.get('SYSTEM_DIRS');

/* const searchTypes = {
    all: () => '["ALL"]',
    fromAddress: (address) => `["FROM", "${address}", "ALL"]`,
    keyword: (needle) => `["FROM", "${needle}", "OR", "SUBJECT", "${needle}", "OR", "TO", "${needle}", "OR", "CC", "${needle}", "ALL"]`,
    unSeen: () => '["UNSEEN"]',
}; */

export const mapKeyToVal = ({ sortDirection, sortFieldId }) => {
    // Parse and validate inputs
    const fieldId = parseInt(sortFieldId, 10);
    const isByAscDescOrSize = fieldId === 0 || fieldId === 3;

    // Determine sort direction depend of filters
    const sortDir = sortDirection.includes(isByAscDescOrSize ? 'desc' : 'asc')
        ? MW.get('REVERSE')
        : '';

    // Map sort field
    const sortBy = MFL[fieldId] || null;
    return { sortDirection: sortDir, sortField: sortBy };
};

export const getSearchBody = (args, sortTerms) => {
    const { keyword, params, type, inFolders: folders } = args;
    const bodies = {
        advancedSearch: { folders, type, ...params },
        fromAddress: { folders, from: keyword },
        unSeen: { folders, seen: false },
        keyword: {
            folders,
            sortTerms,
            subject: keyword,
            ...(folders.includes(MSD.SENT) || folders.includes(MSD.DRAFT) ? { to: keyword } : {from: keyword}),
            type: 'quick'
        },
        default: {
            folders,
            sortTerms,
            cc: args?.fromAddress ? null : keyword, // fixed MAIL-6092, Filled cc parameter disables the execution of the test when filtered by fromAddress. (With a filled cc, there will be more results because the searched email could be added as cc, but the user is only searching by from)
            from: keyword,
            subject: keyword,
            to: keyword,
        }
    };

    return Object.hasOwnProperty.call(bodies, type)
        ? bodies[type]
        : bodies.default;
};

export const formatString = {
    query(params) {
        // console.log(params);
        const { searchTerms, sortTerms } = params;
        return `{"searchTerms":${searchTerms},"sortTerms":${sortTerms}}`;

    },
    sortTerms(params) {
        const { sortDirection, sortField } = params;
        return '["(' + `${sortDirection} ${sortField}`.trim() + ')"]';
    },
    searchSortTerms(params) {
        const { sortDirection, sortField } = params;
        return ''+ `${sortDirection} ${sortField}`.trim() + '';
    }
};
